// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3weyr","col":"styles_col__1pjU5","fulfillmentStatus":"styles_fulfillmentStatus__BM_yT","emailCol":"styles_emailCol__3uxoA"};